/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { configureStore } from '@reduxjs/toolkit'
import { routerMiddleware } from 'connected-react-router';
import { enableBatching } from 'redux-batched-actions';
import { connectRouter } from 'connected-react-router';
// iui
import {
    appStatus,
    messageStatus,
    modalStatus,
    history
} from '@insticator/insticator-ui'; // iui-material
// slices of state
import sessionSlice from '../slices/session';
import accountSlice from '../slices/account';
import appSlice from '../slices/app';
import revenueSlice from '../slices/revenue'
import involvementConfigSlice from '../slices/involvement/configuration';
import engagementSlice from '../slices/engagement';
import commentingSlice from '../slices/commenting'
import triviaAndPollsSlice from '../slices/triviapolls'
import reportSlice from "../slices/report";
import companySettingsSlice from '../slices/settings/companySettings';
import settingsSlice from "../slices/settings";
import revenueBetaSlice from "../slices/revenue_beta";
import revenueOverviewSlice from "../slices/revenue_overview";
import moderationSlice from '../slices/moderation'
import commentingV2Slice from '../slices/commentingv2'
import productManagerSlice from '../slices/productmanager';
import profileConfigSlice from 'state/slices/profile';
import mcmSlice from "../slices/mcm";
import migrationStatusSlice from 'state/slices/migration';
import trendingNowV2Slices from 'state/slices/trendingnowv2';
import articleSentimentV2Slice from 'state/slices/articlesentimentv2';


// /* ========== ~~~~~~~~~~ STORE (application state) ~~~~~~~~~~ ========== */
// STORE
// configure our store of application state
export default configureStore({
    reducer: {
        session: sessionSlice,
        app: appSlice,
        account: accountSlice,
        involvementConfig: involvementConfigSlice,
        // legacy commenting slices
        engagement: engagementSlice,
        commenting: commentingSlice,
        triviaAndPolls: triviaAndPollsSlice,
        // commenting 2.0 slices
        moderation: moderationSlice,
        commentingV2: commentingV2Slice,
        productManager: productManagerSlice,
        migrationStatus: migrationStatusSlice,
        // trending now 2.0 slice
        trendingNowV2: trendingNowV2Slices,
        // article sentiment 2.0 slice
        articleSentimentV2: articleSentimentV2Slice,
        // revenue slices
        revenue: revenueSlice,
        revenueBeta: revenueBetaSlice,
        revenueOverview: revenueOverviewSlice,
        //  reports and settings
        report: reportSlice,
        companySettings: companySettingsSlice,
        profile: profileConfigSlice,
        settings: settingsSlice,
        mcm: mcmSlice,
        router: connectRouter(history),
        messageStatus,
        modalStatus,
        appStatus,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: { ignoredPaths: ['messageStatus', 'modalStatus', 'contentToDisplay'], ignoredActionPaths: ['message', 'modalStatus', 'contentToDisplay'] }}).concat(routerMiddleware(history)),
    // devTools: process.env.NODE_ENV !== 'production',
    devTools: true,
    enhancers: [enableBatching]
});

